var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 123,
    viewBox: "0 0 263 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.57 60.1003H190.33C188.84 60.1003 187.63 58.8904 187.63 57.4004V21.3104C187.63 19.8204 188.84 18.6104 190.33 18.6104H246.57C248.06 18.6104 249.27 19.8204 249.27 21.3104V57.4004C249.26 58.8904 248.06 60.1003 246.57 60.1003Z",
    fill: "#DBE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26 25.0401H187.62V20.7101C187.62 19.5501 188.56 18.6201 189.71 18.6201H247.16C248.32 18.6201 249.25 19.5601 249.25 20.7101V25.0401H249.26Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.2 23.5007C240.117 23.5007 240.86 22.7575 240.86 21.8407C240.86 20.9239 240.117 20.1807 239.2 20.1807C238.283 20.1807 237.54 20.9239 237.54 21.8407C237.54 22.7575 238.283 23.5007 239.2 23.5007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.24 23.5007C235.157 23.5007 235.9 22.7575 235.9 21.8407C235.9 20.9239 235.157 20.1807 234.24 20.1807C233.323 20.1807 232.58 20.9239 232.58 21.8407C232.58 22.7575 233.323 23.5007 234.24 23.5007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.17 23.5007C245.087 23.5007 245.83 22.7575 245.83 21.8407C245.83 20.9239 245.087 20.1807 244.17 20.1807C243.253 20.1807 242.51 20.9239 242.51 21.8407C242.51 22.7575 243.253 23.5007 244.17 23.5007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.74 64.4906H225.48C223.81 64.4906 222.46 63.1406 222.46 61.4706V59.8706C222.46 58.2006 223.81 56.8506 225.48 56.8506H252.74C254.41 56.8506 255.76 58.2006 255.76 59.8706V61.4706C255.76 63.1406 254.41 64.4906 252.74 64.4906Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.57 63.3701V67.4701L233.45 63.3701H229.57Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44 54.5805H211.82C211.1 54.5805 210.51 53.9905 210.51 53.2705V52.5805C210.51 51.8605 211.1 51.2705 211.82 51.2705H222.44C223.16 51.2705 223.75 51.8605 223.75 52.5805V53.2705C223.75 53.9905 223.17 54.5805 222.44 54.5805Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.82 61.75H250.24",
    stroke: "white",
    strokeWidth: 1.1036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.52 33.5905C232.83 32.9405 236.04 35.0905 236.7 38.4005C237.35 41.7105 235.2 44.9205 231.89 45.5805C228.58 46.2305 225.37 44.0805 224.71 40.7705C224.06 37.4605 226.21 34.2505 229.52 33.5905Z",
    stroke: "#748FFC",
    strokeWidth: 0.8277,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.24 44.5999C224.35 43.6299 223.71 42.4099 223.43 41.0299C222.64 37.0099 225.25 33.1099 229.27 32.3099C233.29 31.5199 237.19 34.1299 237.99 38.1499C238.48 40.6399 237.67 43.0799 236.03 44.7699C235.76 45.0499 235.46 45.3099 235.15 45.5399",
    stroke: "#748FFC",
    strokeWidth: 0.8277,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15 46.8604C231.37 47.0104 230.59 47.0404 229.83 46.9504C228.57 46.8004 227.39 46.3304 226.39 45.6104",
    stroke: "#748FFC",
    strokeWidth: 0.8277,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.17 42.2602C238.13 45.1602 235.64 47.4702 232.39 48.1102C227.48 49.0802 222.72 45.8902 221.75 40.9802C221.35 38.9402 221.66 36.9302 222.52 35.2002",
    stroke: "#748FFC",
    strokeWidth: 0.8277,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.09 32.9705C225.33 31.6705 226.98 30.7205 228.88 30.3505C233.79 29.3805 238.55 32.5705 239.52 37.4805",
    stroke: "#748FFC",
    strokeWidth: 0.8277,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.6 28.8701C236.07 29.2801 239.93 32.5801 240.84 37.2101C241.95 42.8401 238.29 48.3101 232.66 49.4301",
    stroke: "#748FFC",
    strokeWidth: 0.8277,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.1 43.3705C220.81 42.7005 220.59 41.9905 220.44 41.2405C219.35 35.7305 222.83 30.3805 228.25 29.1005C228.37 29.0705 228.5 29.0405 228.62 29.0205",
    stroke: "#748FFC",
    strokeWidth: 0.8277,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9196 82.2807H5.09949C2.29949 82.2807 0.0195312 80.0107 0.0195312 77.2007V17.5507C0.0195312 14.7507 2.28949 12.4707 5.09949 12.4707H97.9196C100.72 12.4707 103 14.7407 103 17.5507V77.2007C103 80.0107 100.73 82.2807 97.9196 82.2807Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9099 29.2607H6.08984V68.6507H89.9099V29.2607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8594 24.8505H8.3894C6.4594 24.8505 4.89941 23.2905 4.89941 21.3605V20.2605C4.89941 18.3305 6.4594 16.7705 8.3894 16.7705H29.8594C31.7894 16.7705 33.3494 18.3305 33.3494 20.2605V21.3605C33.3494 23.2905 31.7894 24.8505 29.8594 24.8505Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1996 62.5905H38.6996C37.9796 62.5905 37.3896 62.0005 37.3896 61.2805V60.8706C37.3896 60.1506 37.9796 59.5605 38.6996 59.5605H48.1996C48.9196 59.5605 49.5096 60.1506 49.5096 60.8706V61.2805C49.5096 62.0005 48.9296 62.5905 48.1996 62.5905Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4097 62.5905H59.9097C59.1897 62.5905 58.5996 62.0005 58.5996 61.2805V60.8706C58.5996 60.1506 59.1897 59.5605 59.9097 59.5605H69.4097C70.1297 59.5605 70.7196 60.1506 70.7196 60.8706V61.2805C70.7196 62.0005 70.1297 62.5905 69.4097 62.5905Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.72 16.1503H45.47C42.59 16.1503 40.25 13.8103 40.25 10.9303V9.29031C40.25 6.41031 42.59 4.07031 45.47 4.07031H87.72C90.6 4.07031 92.9399 6.41031 92.9399 9.29031V10.9303C92.9399 13.8103 90.6 16.1503 87.72 16.1503Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5098 14.3799V20.8599L57.6298 14.3799H51.5098Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4697 8.56055H71.7297",
    stroke: "white",
    strokeWidth: 1.0099,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4697 11.5898H84.8597",
    stroke: "white",
    strokeWidth: 1.0099,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1799 43.2803H30.3398V54.7503H31.1799V43.2803Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5802 48.1904H31.7402V54.7504H32.5802V48.1904Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9796 49.0205H33.1396V54.7605H33.9796V49.0205Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.38 45.5801H34.54V54.7501H35.38V45.5801Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7697 49.3398H35.9297V54.7498H36.7697V49.3398Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1702 45.1602H37.3301V54.7502H38.1702V45.1602Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5695 43.5703H38.7295V54.7503H39.5695V43.5703Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9698 46.4902H40.1299V54.7502H40.9698V46.4902Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3595 45.1602H41.5195V54.7502H42.3595V45.1602Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7599 44.5107H42.9199V54.7507H43.7599V44.5107Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1604 47.8506H44.3203V54.7506H45.1604V47.8506Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5598 45.3203H45.7197V54.7503H46.5598V45.3203Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.13 43.2803H58.29V54.7503H59.13V43.2803Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.34 52.8701H55.5V54.7501H56.34V52.8701Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9396 51.5801H54.0996V54.7601H54.9396V51.5801Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9493 45.5801H47.1094V54.7501H47.9493V45.5801Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5403 49.3398H52.7002V54.7498H53.5403V49.3398Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7404 45.1602H56.9004V54.7502H57.7404V45.1602Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1495 43.5703H51.3096V54.7503H52.1495V43.5703Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7501 46.4902H49.9102V54.7502H50.7501V46.4902Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3302 45.1602H62.4902V54.7502H63.3302V45.1602Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9299 44.5107H61.0898V54.7507H61.9299V44.5107Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3497 47.8506H48.5098V54.7506H49.3497V47.8506Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5295 45.3203H59.6895V54.7503H60.5295V45.3203Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7198 48.1904H63.8799V54.7504H64.7198V48.1904Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1202 52.8701H65.2803V54.7501H66.1202V52.8701Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5197 51.5801H66.6797V54.7601H67.5197V51.5801Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9202 45.5801H68.0801V54.7501H68.9202V45.5801Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3098 49.3398H69.4697V54.7498H70.3098V49.3398Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7101 45.1602H70.8701V54.7502H71.7101V45.1602Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1095 43.5703H72.2695V54.7503H73.1095V43.5703Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5099 46.4902H73.6699V54.7502H74.5099V46.4902Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8995 45.1602H75.0596V54.7502H75.8995V45.1602Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3 44.5107H76.46V54.7507H77.3V44.5107Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6993 47.8506H77.8594V54.7506H78.6993V47.8506Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0997 45.3203H79.2598V54.7503H80.0997V45.3203Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4904 45.5801H80.6504V54.7501H81.4904V45.5801Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2903 46.4902H83.4502V54.7502H84.2903V46.4902Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8898 47.8506H82.0498V54.7506H82.8898V47.8506Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9795 37.1201H52.2495",
    stroke: "#748FFC",
    strokeWidth: 1.0099,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2393 38.8302L51.9492 37.1202L50.2393 35.4102H51.6992L53.4093 37.1202L51.6992 38.8302H50.2393Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8792 36.4106C84.7131 36.4106 85.3892 35.7346 85.3892 34.9006C85.3892 34.0667 84.7131 33.3906 83.8792 33.3906C83.0452 33.3906 82.3691 34.0667 82.3691 34.9006C82.3691 35.7346 83.0452 36.4106 83.8792 36.4106Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1799 36.4106C68.0139 36.4106 68.6898 35.7346 68.6898 34.9006C68.6898 34.0667 68.0139 33.3906 67.1799 33.3906C66.346 33.3906 65.6699 34.0667 65.6699 34.9006C65.6699 35.7346 66.346 36.4106 67.1799 36.4106Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1096 36.4106C59.9436 36.4106 60.6196 35.7346 60.6196 34.9006C60.6196 34.0667 59.9436 33.3906 59.1096 33.3906C58.2757 33.3906 57.5996 34.0667 57.5996 34.9006C57.5996 35.7346 58.2757 36.4106 59.1096 36.4106Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.26 36.4106C76.094 36.4106 76.77 35.7346 76.77 34.9006C76.77 34.0667 76.094 33.3906 75.26 33.3906C74.4261 33.3906 73.75 34.0667 73.75 34.9006C73.75 35.7346 74.4261 36.4106 75.26 36.4106Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08984 12.6006H42.4398",
    stroke: "#748FFC",
    strokeWidth: 1.0099,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6294 23.33C12.0212 23.33 13.1494 22.2018 13.1494 20.81C13.1494 19.4183 12.0212 18.29 10.6294 18.29C9.23764 18.29 8.10938 19.4183 8.10938 20.81C8.10938 22.2018 9.23764 23.33 10.6294 23.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2095 23.33C20.6012 23.33 21.7295 22.2018 21.7295 20.81C21.7295 19.4183 20.6012 18.29 19.2095 18.29C17.8177 18.29 16.6895 19.4183 16.6895 20.81C16.6895 22.2018 17.8177 23.33 19.2095 23.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7993 23.33C29.1911 23.33 30.3192 22.2018 30.3192 20.81C30.3192 19.4183 29.1911 18.29 27.7993 18.29C26.4076 18.29 25.2793 19.4183 25.2793 20.81C25.2793 22.2018 26.4076 23.33 27.7993 23.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.21 105.65H120.86V114.48H135.21V105.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.28 110.65L64.5 111.1C64.5 110.95 64.5 110.8 64.5 110.65C64.5 80.1002 90.13 54.9502 121.29 54.9502C152.44 54.9502 178.08 80.0902 178.08 110.65H121.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.08 116C187.08 116 174.8 107.86 155.85 107.86C142.41 107.86 133.92 111.77 130.11 114.04C129.11 114.64 127.67 114.64 126.67 114.04C122.87 111.77 114.37 107.86 100.93 107.86C81.9703 107.86 69.7002 116 69.7002 116L128.39 115.64L187.08 116Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.421 64.4608L132.881 42.5008L113.301 33.8008L105.681 61.7408C105.681 61.7408 117.101 73.1608 133.421 64.4608Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.641 42.5005L133.961 62.6805L133.261 38.0305L123.081 31.2705L116.121 33.8005",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8 47.94C133.311 47.94 139.4 39.9036 139.4 29.99C139.4 20.0765 133.311 12.04 125.8 12.04C118.289 12.04 112.2 20.0765 112.2 29.99C112.2 39.9036 118.289 47.94 125.8 47.94Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.61 27.2705C129.61 27.2705 132.87 33.1605 129.61 33.4805",
    stroke: "#364FC7",
    strokeWidth: 0.5518,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.12 5.64013C123.12 5.64013 110.61 0.0701265 106.26 14.6601C101.75 29.7901 113.88 36.5101 113.88 36.5101V26.7201C113.88 26.7201 118.78 24.7001 125.3 16.4601C125.3 16.4601 130.74 24.6901 142.16 17.5401C142.16 17.5401 139.44 14.9601 142.16 11.0401C144.88 7.12013 131.28 -5.36987 123.12 5.64013Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.65 38.2273C115.63 37.5137 116.601 35.1791 115.82 33.0126C115.039 30.8462 112.802 29.6683 110.822 30.3818C108.843 31.0954 107.871 33.4301 108.652 35.5965C109.433 37.763 111.671 38.9408 113.65 38.2273Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.887 35.698C140.866 34.9844 141.838 32.6498 141.057 30.4833C140.276 28.3169 138.038 27.139 136.059 27.8525C134.079 28.5661 133.108 30.9008 133.889 33.0673C134.67 35.2337 136.907 36.4115 138.887 35.698Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.421 27.1602C134.541 25.5902 132.55 25.0202 130.98 25.9102",
    stroke: "#364FC7",
    strokeWidth: 0.5518,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84 26.2303C124.33 25.2403 122.31 25.6703 121.32 27.1803",
    stroke: "#364FC7",
    strokeWidth: 0.5518,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.12 39.0604C128.63 40.0504 130.65 39.6204 131.64 38.1104",
    stroke: "#364FC7",
    strokeWidth: 0.5518,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3504 119.94C40.6004 119.94 35.7905 109.71 41.4305 103.01C49.9405 92.91 62.3204 81.56 76.5204 78.96L71.5204 94.64C70.4204 98.09 73.1404 101.57 76.7504 101.33L85.1104 100.78C85.6104 99.82 82.7204 108.87 81.8404 117.41C63.5704 118.46 81.8404 117.41 81.8404 117.41L49.3504 119.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.991 118C199.681 116.98 203.261 106.25 196.881 100.27C187.251 91.2305 173.631 81.4005 159.221 80.4805L166.011 95.4705C167.501 98.7705 173.291 102.16 169.671 102.34V118.89C184.981 118.42 190.991 118 190.991 118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.61 107.54C169.41 106.42 165.14 107.08 163.44 107.18C152.52 107.81 147.95 111.74 146.38 114.39C145.86 115.26 146.81 116.28 147.73 115.85C150.32 114.64 154.78 112.63 156.39 112.25C160.65 111.25 167.89 114.46 170.39 115.53C170.98 115.78 170.2 110.86 169.61 107.54Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.23 116.061C154.76 116.101 154.31 115.831 154.12 115.381C153.89 114.811 154.16 114.171 154.72 113.941L164.87 109.811C165.44 109.581 166.08 109.851 166.31 110.411C166.54 110.981 166.27 111.621 165.71 111.851L155.56 115.981C155.45 116.021 155.34 116.051 155.23 116.061Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.541 115.28H103.471V120.8H157.541V115.28Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9802 120.24L84.7002 120.32C84.7002 120.29 84.7002 120.27 84.7002 120.24C84.7002 116.91 88.4402 114.17 92.9802 114.17C97.5202 114.17 101.26 116.91 101.26 120.24H92.9802Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2007 106.761C71.2007 106.761 72.3008 107.861 76.7208 107.861C81.1308 107.861 84.4908 104.001 88.8608 104.551C93.2308 105.101 93.2708 108.961 93.2708 108.961L89.9607 114.481C89.9607 114.481 86.6508 116.691 81.1308 116.691C77.1508 116.691 74.5108 115.591 72.3008 116.691C70.1008 117.791 71.2007 106.761 71.2007 106.761Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5809 113.38C96.3909 113.38 96.1909 113.33 96.0109 113.22L90.4909 109.91C89.9709 109.6 89.8009 108.92 90.1109 108.4C90.4209 107.88 91.1009 107.71 91.6209 108.02L97.1409 111.33C97.6609 111.64 97.8309 112.32 97.5209 112.84C97.3209 113.19 96.9609 113.38 96.5809 113.38Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9306 118.341C94.7006 118.341 94.4706 118.271 94.2706 118.121L89.8606 114.811C89.3706 114.441 89.2706 113.751 89.6406 113.271C90.0106 112.781 90.7006 112.681 91.1806 113.051L95.5906 116.361C96.0806 116.731 96.1806 117.421 95.8106 117.901C95.6006 118.191 95.2606 118.341 94.9306 118.341Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2806 111.17C92.9006 111.17 92.5205 110.97 92.3205 110.61L83.4906 95.1603C83.1906 94.6303 83.3706 93.9603 83.9006 93.6503C84.4306 93.3403 85.1006 93.5303 85.4106 94.0603L94.2406 109.51C94.5406 110.04 94.3605 110.71 93.8305 111.02C93.6505 111.12 93.4606 111.17 93.2806 111.17Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3808 116.971C97.1308 116.971 96.8808 116.881 96.6708 116.711L90.1108 111.181C89.6408 110.791 89.5908 110.091 89.9808 109.621C90.3708 109.151 91.0708 109.091 91.5408 109.491L98.1007 115.021C98.5707 115.411 98.6208 116.111 98.2308 116.581C98.0108 116.841 97.7008 116.971 97.3808 116.971Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9311 109.51C94.7911 109.51 94.6511 109.49 94.5211 109.43L89.0011 107.22C88.4311 106.99 88.1611 106.35 88.3811 105.79C88.6111 105.22 89.2511 104.95 89.8111 105.17L95.331 107.38C95.901 107.61 96.171 108.25 95.951 108.81C95.781 109.25 95.3711 109.51 94.9311 109.51Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.23 105.34H120.89C116.79 105.34 113.47 102.02 113.47 97.9195V58.6895C113.47 54.5895 116.79 51.2695 120.89 51.2695H201.23C205.33 51.2695 208.65 54.5895 208.65 58.6895V97.9195C208.65 102.02 205.33 105.34 201.23 105.34Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.889 122.999H150.569L154.989 86.5791H166.019L171.889 122.999Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.25 42.44H155.01C153.52 42.44 152.311 41.23 152.311 39.74V3.65996C152.311 2.16996 153.52 0.959961 155.01 0.959961H211.25C212.74 0.959961 213.95 2.16996 213.95 3.65996V39.74C213.95 41.23 212.74 42.44 211.25 42.44Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.95 7.37996H152.311V3.04996C152.311 1.88996 153.251 0.959961 154.401 0.959961H211.85C213.01 0.959961 213.94 1.89996 213.94 3.04996V7.37996H213.95Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.891 5.83953C204.807 5.83953 205.551 5.09632 205.551 4.17953C205.551 3.26274 204.807 2.51953 203.891 2.51953C202.974 2.51953 202.23 3.26274 202.23 4.17953C202.23 5.09632 202.974 5.83953 203.891 5.83953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.921 5.83953C199.838 5.83953 200.581 5.09632 200.581 4.17953C200.581 3.26274 199.838 2.51953 198.921 2.51953C198.004 2.51953 197.261 3.26274 197.261 4.17953C197.261 5.09632 198.004 5.83953 198.921 5.83953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.86 5.83953C209.777 5.83953 210.52 5.09632 210.52 4.17953C210.52 3.26274 209.777 2.51953 208.86 2.51953C207.943 2.51953 207.2 3.26274 207.2 4.17953C207.2 5.09632 207.943 5.83953 208.86 5.83953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.91 38.8294V10.8994",
    stroke: "#91A7FF",
    strokeWidth: 1.1036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.78 13.0996L182.91 11.2296L181.04 13.0996V11.5096L182.91 9.63965L184.78 11.5096V13.0996Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.58 25.3896H169.58",
    stroke: "#91A7FF",
    strokeWidth: 1.1036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.78 23.5195L169.9 25.3895L171.78 27.2595H170.19L168.32 25.3895L170.19 23.5195H171.78Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 14.25L180.54 25.79C181.52 28.29 184.42 28.17 185.28 25.61L189.06 14.25",
    stroke: "#5C7CFA",
    strokeWidth: 1.1036,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.36 28.7998L166.37 32.8098",
    stroke: "#748FFC",
    strokeWidth: 1.1036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.36 32.8098L166.37 28.7998",
    stroke: "#748FFC",
    strokeWidth: 1.1036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.761 77.3729L249.162 82.3379L254.127 90.9373L262.726 85.9723L257.761 77.3729Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.53 16.1498C255.61 15.7198 255.84 15.3298 256.23 15.0598L259.83 12.5498C260.6 12.0098 261.65 12.1998 262.19 12.9698C262.73 13.7398 262.54 14.7898 261.77 15.3298L258.17 17.8398C257.4 18.3798 256.35 18.1898 255.81 17.4198C255.54 17.0398 255.46 16.5798 255.53 16.1498Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.34 109.77C252.256 109.77 253 109.027 253 108.11C253 107.193 252.256 106.45 251.34 106.45C250.423 106.45 249.68 107.193 249.68 108.11C249.68 109.027 250.423 109.77 251.34 109.77Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.51 119.68L227.62 110.31",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.43 98.4799L222.1 89.3398",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.99 1.11035L230.72 8.28035",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItRightImage);
export default __webpack_public_path__ + "static/media/itRightImage.e91adb2cf2b2daa0949ba02b18e448db.svg";
export { ForwardRef as ReactComponent };